var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiv9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.78125,
    width: 46,
    height: 46,
    rx: 13,
    fill: "#06BA63"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2060_58480)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.711 42.2112C22.3105 42.2112 20.9118 41.6794 19.8427 40.6177L18.5132 39.2882C17.9978 38.7746 17.3075 38.4904 16.5754 38.4886H14.705C11.6817 38.4886 9.22126 36.0281 9.22126 33.0049V31.1327C9.21944 30.4023 8.93532 29.7121 8.41991 29.193L7.11227 27.8872C4.97049 25.7582 4.96139 22.2778 7.09223 20.1342L8.42174 18.8029C8.93532 18.2875 9.21944 17.5972 9.22126 16.8651V14.9966C9.22126 11.9715 11.6817 9.51101 14.705 9.51101H16.5772C17.3075 9.51101 17.996 9.22689 18.515 8.70784L19.8245 7.40202C21.9535 5.26024 25.4321 5.24931 27.5775 7.38198L28.907 8.71149C29.4242 9.22689 30.1126 9.51101 30.843 9.51101H32.7152C35.7384 9.51101 38.1989 11.9715 38.1989 14.9966V16.8669C38.2008 17.5972 38.4849 18.2875 39.0003 18.8065L40.3079 20.1142C41.3442 21.145 41.9179 22.5182 41.9234 23.9843C41.927 25.4413 41.3661 26.8127 40.3443 27.849C40.3261 27.8672 40.3097 27.8872 40.2915 27.9036L38.9985 29.1967C38.4849 29.7121 38.2008 30.4023 38.1989 31.1345V33.0049C38.1989 36.0281 35.7384 38.4886 32.7152 38.4886H30.843C30.1126 38.4904 29.4224 38.7746 28.9052 39.29L27.5957 40.5976C26.5285 41.6721 25.1188 42.2112 23.711 42.2112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.71 29.12L17 25.42L18.41 24L20.71 26.3L29 18L30.41 19.42L20.71 29.12Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2060_58480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(5.5 5.78125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiv9);
export default __webpack_public_path__ + "static/media/div9.29eadf4bd3105fb2e1a2b7e449ad48ef.svg";
export { ForwardRef as ReactComponent };